import { render, staticRenderFns } from "./fieldVideoUpload.vue?vue&type=template&id=e0bdf988&scoped=true"
import script from "./fieldVideoUpload.vue?vue&type=script&lang=js"
export * from "./fieldVideoUpload.vue?vue&type=script&lang=js"
import style0 from "./fieldVideoUpload.vue?vue&type=style&index=0&id=e0bdf988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bdf988",
  null
  
)

export default component.exports